import { Fragment, useState, useEffect, useRef } from "react";
import "../css/styles.css";
import { Dialog, Transition } from "@headlessui/react";
import moment from "moment";
import { ToastContainer, toast } from "react-toastify";
import { db } from "../firebase";
import { doc, getDoc, setDoc } from "firebase/firestore";
import { v4 as uuidv4 } from "uuid";

const EditModal = ({
  placeData,
  open,
  setOpen,
  cancelButtonRef,
  change,
  setChange,
  setChangeType,
  changeType,
  collection,
  documentId
}) => {
  const [currentDate, setCurrentDate] = useState();
  const [containerNumber, setContainerNumber] = useState();
  const [typeOfContainer, setTypeOfContainer] = useState();
  const selectRef = useRef();

  useEffect(() => {
    if(placeData){
      setCurrentDate(placeData.date)
    }
  }, [placeData])

  useEffect(() => {
    if(placeData){
      setTypeOfContainer(placeData.type)
      setContainerNumber(placeData.containerNumber);
    }
  }, [placeData])

  const setSelect = () => {
    const select = document.querySelector('#typeOfContainer');

    if(select && placeData){
      select.value = (typeOfContainer ? typeOfContainer : placeData.type);
    }
  }

  useEffect(() => {
    setTimeout(setSelect, 100)
   
  }, [placeData, typeOfContainer, changeType])

  const handleEdit = async () => {
    const docRef = doc(db, collection, documentId);
    const response = await getDoc(docRef);
    if(response.exists()){
      const parking1 = response.data().parking;
      const index = parking1.findIndex((place) => place.uid === placeData.uid);
      parking1.splice(index, 1);

      const object = {
        date: currentDate ? currentDate : placeData.date,
        containerNumber: containerNumber ? containerNumber : placeData.containerNumber,
        type: typeOfContainer ? typeOfContainer : placeData.typeOfContainer,
        uid: placeData.uid,
        parking: placeData.parking,
        place: placeData.place,
        section: (placeData.section === undefined ? '' : placeData.section),

      }

      parking1.push(object);
     
      setDoc(docRef, {
        parking: parking1
      }).then(() => { setOpen(false); setChange(!change) })
    }
  };

  const handleDelete = async () => {
    const docRef = doc(db, collection, documentId);
    const response = await getDoc(docRef);
    if(response.exists()){
      const parking1 = response.data().parking;
      const index = parking1.findIndex((place) => place.uid === placeData.uid);
      parking1.splice(index, 1);

      setDoc(docRef, {
        parking: parking1
      }).then(() => { setOpen(false); setChange(!change) })
    }
  };

  const openToast = (message) => {
    const Toastify__toast = document.querySelector(".Toastify__toast ");
    if (Toastify__toast === null) {
      toast.error(message, {
        position: "top-center",
      });
    }
  };

  return (
    <>
      {" "}
      <ToastContainer
        style={{ width: "800px", zIndex: "10000" }}
        autoClose={2000}
      />
      <Transition.Root show={open}>
        <Dialog
          as="div"
          className="relative z-10"
          initialFocus={cancelButtonRef}
          onClose={() => setOpen(false)}
        >
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
          </Transition.Child>

          <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
            <div className="flex min-h-full items-end justify-center align-center p-4 text-center sm:items-center sm:p-0">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                enterTo="opacity-100 translate-y-0 sm:scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              >
                <Dialog.Panel
                  style={{
                    display: "flex",
                    flexFlow: "column nowrap",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "450px",
                  }}
                  className="relative width-2 transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full"
                >
                  <div
                    style={{ width: "100%", height: "83%" }}
                    className="bg-white"
                  >
                    <div
                      style={{ width: "100%" }}
                      className="sm:flex sm:flex-col sm:items-center"
                    >
                      <div
                        style={{
                          display: "flex",
                          flexFlow: "column nowrap",
                          justifyContent: "center",
                          alignItems: "center",
                          width: "100%",
                        }}
                        className="text-center mt-3"
                      >
                        <Dialog.Title
                          as="h3"
                          className="text-sm font-semibold leading-6 text-gray-900"
                        >
                          Container information
                        </Dialog.Title>
                        <div
                          style={{ paddingLeft: "20px", paddingRight: "20px" }}
                          className="container text-left"
                        >
                          <div>
                            <label
                              htmlFor="arrivalDate"
                              className="form-label"
                            >
                              Arrival date
                            </label>
                            <input
                              type="datetime-local"
                              className="form-control"
                              id="arrivalDate"
                              placeholder=""
                              name="arrivalDate"
                              value={currentDate}
                              onChange={(e) => {
                                setCurrentDate(e.target.value);
                              }}
                              required
                            />
                          </div>
                          <div>
                            <label
                              htmlFor="containerNumber"
                              className="form-label"
                            >
                              Container number
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              id="containerNumber"
                              name="containerNumber"
                              defaultValue={placeData && placeData.containerNumber}
                              onChange={(e) =>
                                setContainerNumber(e.target.value)
                              }
                              required
                            />
                          </div>
                          <div>
                            <label
                              htmlFor="typeOfContainer"
                              className="form-label"
                            >
                              Type of container
                            </label>
                            <select
                              className="form-control"
                              id="typeOfContainer"
                              name="typeOfContainer"
                              type="text"
                              ref={selectRef}
                              onChange={(e) =>
                                setTypeOfContainer(e.target.value)
                              }
                              required
                            >
                              <option>Amazon</option>
                              <option>Slam</option>
                            </select>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="bg-gray-50 px-4 py-3 w-full sm:flex sm:flex-row-reverse sm:px-6">
                    <button
                      type="button"
                      style={{
                        borderWidth: "2px",
                        borderStyles: "solid",
                        borderColor: "black",
                        cursor: "pointer",
                      }}
                      className="amazon-button inline-flex w-full justify-center rounded-md px-3 py-2 text-sm"
                      onClick={() => handleDelete()}
                      id="modal-button"
                    >
                      Release field
                    </button>
                    <button
                      type="button"
                      style={{
                        borderWidth: "2px",
                        borderStyles: "solid",
                        borderColor: "black",
                        cursor: "pointer",
                      }}
                      className="amazon-button inline-flex w-full justify-center rounded-md px-3 py-2 text-sm"
                      onClick={() => handleEdit()}
                      id="modal-button"
                    >
                      Edit
                    </button>
                    <button
                      type="button"
                      style={{ cursor: "pointer" }}
                      className="amazon-button-2 inline-flex w-full justify-center rounded-md px-3 py-2 text-sm"
                      onClick={() => setOpen(false)}
                      id="modal-button"
                    >
                      Close
                    </button>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition.Root>
    </>
  );
};

export default EditModal;
